
import React, { useState, useEffect } from 'react';
import { Gallery } from './showroom/gallery';
import { ImageModal } from './showroom/image-modal';
import type { ImageType } from './showroom/types';

// Import all showroom images directly
import showroomImg1 from '../assets/showroom/1_Elektro1.jpg';
import showroomImg2 from '../assets/showroom/2_Elektro2.jpg';
import showroomImg3 from '../assets/showroom/3_VDE.JPG';
import showroomImg4 from '../assets/showroom/4_VDE.jpg';
import showroomImg5 from '../assets/showroom/5_PV1.jpg';
import showroomImg6 from '../assets/showroom/6_PV2.jpg';
import showroomImg7 from '../assets/showroom/7_PV3.jpg';
import showroomImg8 from '../assets/showroom/8_PV4.jpg';
import showroomImg9 from '../assets/showroom/9_PV6.jpeg';
import showroomImg10 from '../assets/showroom/10_PV5.jpg';
import showroomImg11 from '../assets/showroom/11_Türsprech.jpeg';
import showroomImg12 from '../assets/showroom/12_Kamera.jpg';
import showroomImg13 from '../assets/showroom/13_Smarthome1.jpg';
import showroomImg14 from '../assets/showroom/14_Smarthome2.jpg';
import showroomImg15 from '../assets/showroom/15_Wallbox1.jpg';
import showroomImg16 from '../assets/showroom/16_Wallbox2.jpg';

const electricalImages: ImageType[] = [
  {
    src: showroomImg1,
    alt: "Zähler und Verteilerschrank EFH",
  },
  {
    src: showroomImg2,
    alt: "KNX Verteilerschrank",
  },
  {
    src: showroomImg3,
    alt: "Prüfung nach VDE 100-600",
  },
  {
    src: showroomImg4,
    alt: "Prüfung nach VDE 0126-23",
  },
  {
    src: showroomImg5,
    alt: "Montage Solaranlage",
  },
  {
    src: showroomImg6,
    alt: "Montage Solaranlage",
  },
  {
    src: showroomImg7,
    alt: "Installation Solaranlage",
  },
  {
    src: showroomImg8,
    alt: "Installation Solaranlage",
  },
  {
    src: showroomImg9,
    alt: "Installation Solaranlage",
  },
  {
    src: showroomImg10,
    alt: "Installation Solaranlage",
  },
  {
    src: showroomImg11,
    alt: "Installation Türsprechanlage",
  },
  {
    src: showroomImg12,
    alt: "Installation Videoüberwachung",
  },
  {
    src: showroomImg13,
    alt: "Impression Smarthome",
  },
  {
    src: showroomImg14,
    alt: "Impression Beleuchtung",
  },
  {
    src: showroomImg15,
    alt: "Installation Wallbox",
  },
  {
    src: showroomImg16,
    alt: "Installation Wallbox",
  },
];

const ShowroomSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [selectedImage, setSelectedImage] = useState<ImageType | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imagesPerSlide = window.innerWidth < 640 ? 2 : 4;
  const totalSlides = Math.ceil(electricalImages.length / imagesPerSlide);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    if (!isModalOpen) {
      const interval = setInterval(() => {
        setDirection(1);
        setCurrentIndex(prevIndex => prevIndex + 1);
      }, 10000);
      
      return () => clearInterval(interval);
    }
  }, [isModalOpen]);

  const goToPrevious = () => {
    setDirection(-1);
    setCurrentIndex((prevIndex) => prevIndex - 1);
  };

  const goToNext = () => {
    setDirection(1);
    setCurrentIndex((prevIndex) => prevIndex + 1);
  };

  const openImageModal = (image: ImageType) => {
    setSelectedImage(image);
    setIsModalOpen(true);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const normalizedIndex = ((currentIndex % totalSlides) + totalSlides) % totalSlides;

  const handleSlideChange = (index: number) => {
    setDirection(index > normalizedIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  return (
    <section id="showroom" className="py-20 bg-gradient-to-r from-primary/10 to-secondary/20">
      <div className="container relative">
        <div className="text-center mb-16">
          <h2 className="text-primary text-3xl md:text-4xl font-bold mt-2 mb-4">
            Elektrische Arbeiten und Projekte
          </h2>
          <p className="text-paragraph max-w-2xl mx-auto">
            Lassen Sie sich von erfolgreich durchgeführten Projekten aus den Bereichen Elektroinstallation, Smarthome und Energietechnik inspirieren.
          </p>
        </div>

        <Gallery
          images={electricalImages}
          currentIndex={currentIndex}
          direction={direction}
          totalSlides={totalSlides}
          normalizedIndex={normalizedIndex}
          imagesPerSlide={imagesPerSlide}
          onPrevious={goToPrevious}
          onNext={goToNext}
          onImageClick={openImageModal}
          onSlideChange={handleSlideChange}
        />

        <div className="mt-16">
          <div className="elfsight-app-2daedc3a-1dfc-459a-85c2-018436ee6626" data-elfsight-app-lazy></div>
        </div>
      </div>

      <ImageModal
        image={selectedImage}
        isOpen={isModalOpen}
        onClose={closeImageModal}
      />
    </section>
  );
};

export default ShowroomSection;
